var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.993,14.795L28,14.8V6.667C28,5.96 27.719,5.281 27.219,4.781C26.719,4.281 26.041,4 25.333,4H24V1.334H21.333V4H10.667V1.334H8V4H6.667C5.187,4 4,5.187 4,6.667V25.333C4,26.041 4.281,26.719 4.781,27.219C5.281,27.719 5.959,28 6.667,28H14.795C16.602,29.779 18.782,30.668 21.334,30.668C23.915,30.668 26.116,29.758 27.935,27.939C29.754,26.12 30.664,23.919 30.664,21.338C30.664,18.784 29.774,16.603 27.993,14.795ZM25.333,10.667H6.667V25.333H12.868C12.292,24.122 12.004,22.79 12.004,21.338C12.004,18.757 12.914,16.556 14.733,14.737C16.552,12.917 18.753,12.008 21.334,12.008C22.788,12.008 24.121,12.296 25.333,12.874V10.667ZM26.605,18.912L20.028,25.536L16.063,21.571L17.369,20.218L20.028,22.877L25.299,17.606L26.605,18.912Z",
    fill: "#589BB0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.bc0e290dc17f7af7840567ff1ac410eb.svg";
export { ForwardRef as ReactComponent };